<div class="forgetPasswordFix">
  <div class="header">
    <div class="container-fluid">
      <div class="row">
        <div class="col-xl-12">
          <h2 class="text-center my-4">
            <img src="assets\images\olios_logo.png" alt="Olios Logo" height="100" />
          </h2>
        </div>
      </div>
    </div>
  </div>

  <div class="container">
    <div class="row d-flex justify-content-center">
      <div class="col-xl-8">
        <div class="forgot box-content">
          <img src="assets/images/fp.svg" alt="Forgot Password Icon" width="100" />
          <h2 class="mb-5">Forgot Password</h2>

          <form [formGroup]="form" (ngSubmit)="sendEmail()">
            <input type="email" autocomplete="on" class="form-control form-control-lg input-custom mb-4" placeholder="Your email address"
              formControlName="emailAddress" id="emailAddress" aria-label="Your email address" />
            <div class="error" *ngIf="
                form.controls['emailAddress'].hasError('required') &&
                form.controls['emailAddress'].touched">
              <h6 class="text-danger mt-1">Field is required</h6>
            </div>
            <button class="btn btn-primary" type="submit" [disabled]="!form.valid">
              <i class="fas fa-redo-alt mr-1"></i> Reset password
            </button>
            <div class="text-center mt-3">
              <a mat-flat-button style="text-decoration: underline;" routerLink="/login">Back To Login Page</a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</div>
